module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Schwende-Ruete_COA-f8b7500f36f79c688aa4d9b84b8c6c9f.svg";